<template>
  <b-tabs type="is-toggle is-info" expanded v-model="activeTab">
    <b-tab-item label="Vendor Data">
      <div class="columns add-vendor">
        <b-field class="column search-vn">
          <b-input
            placeholder="Enter Vendor Number"
            oninput="this.value; if (this.value.length > 12)
                          this.value = this.value.slice(0, 12);"
            type="text"
            clsss="search-box"
            v-model="searchVN"
          >
          </b-input>
          <b-button
            class="search-button"
            @click="getAllVendorDetailsBySearch()"
            type="is-info"
            outlined
          >
            Search
          </b-button>
        </b-field>
        <b-field label="Vendor Number" class="column">
          <b-input
            placeholder="Enter Vendor Number"
            oninput="this.value; if (this.value.length > 12)
                          this.value = this.value.slice(0, 12);"
            type="text"
            required
            v-model="vendorNumber"
          >
          </b-input>
        </b-field>
        <b-field label="Vendor Name" class="column">
          <b-input
            placeholder="Enter Vendor Name"
            type="text"
            v-model="vendorName"
          >
          </b-input>
        </b-field>
        <b-field label="MCS Code" class="column">
          <b-input
            placeholder="Enter Vendor McsCode"
            type="text"
            v-model="vnMCSCode"
          >
          </b-input>
        </b-field>
        <b-field label="Vendor Category" class="column">
          <b-input
            placeholder="Enter Vendor Category"
            type="text"
            v-model="vnCategory"
          >
          </b-input>
        </b-field>
        <span>
          <b-button
            type="is-info"
            class="column ni-app-add-vendor-button"
            @click="vendorNumber ? addVendorDetails() : ''"
          >
            Add/Update
          </b-button>
        </span>
      </div>
      <div>
        <div class="pagination-wrapper">
          <div class="pagination-header">
            <b-button
              v-show="showVNPreviousButton"
              @click="
                vnPageIndex = vnPageIndex - 1;
                searchVN = '';
                getAllVendorDetails();
              "
              >Previous</b-button
            >
            <b-button
              class="apply-filter"
              v-show="showVNFirstButton"
              @click="
                vnPageIndex = 1;
                searchVN = '';
                getAllVendorDetails();
              "
              >First</b-button
            >
            <span class="page-index"
              >{{ minVNPageIndex }} to {{ maxVNPageIndex }} of
              {{ vnTotalResults }}</span
            >
            <b-button
              v-show="showVNLastButton"
              @click="
                vnPageIndex = vnTotalPages;
                searchVN = '';
                getAllVendorDetails();
              "
              >Last</b-button
            >
            <b-button
              class="apply-filter"
              v-show="showNextButton"
              @click="
                vnPageIndex = vnPageIndex + 1;
                searchVN = '';
                getAllVendorDetails();
              "
              >Next</b-button
            >
            <span class="page-navigator" v-show="vnTotalResults > 10"
              ><span class="show-text">Show</span
              ><b-select
                class="page-display-number"
                v-model="numberOfVNItemsPerPage"
                @input="
                  vnPageIndex =
                    Math.floor(minVNPageIndex / numberOfVNItemsPerPage) + 1;
                  getAllVendorDetails();
                "
                ><option value="10">10</option>
                <option value="20">20</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </b-select></span
            >
          </div>
        </div>
      </div>
      <div class="new-item-submissions-table-wrapper">
        <b-table :data="data" :columns="vendorColumns"> </b-table>
      </div>
    </b-tab-item>
    <b-tab-item label="MCS Data">
      <div v-show="showMcsInputWrapper" class="columns mcs-input-wrapper">
        <b-field label="MCS Code" class="column">
          <b-input
            placeholder="Enter MCS Code"
            type="text"
            required
            v-model="mcsCode"
          >
          </b-input>
        </b-field>
        <b-field label="Product Manager Name" class="column">
          <b-input
            placeholder="Enter Product Manager Name"
            type="text"
            required
            v-model="prodMngrName"
          >
          </b-input>
        </b-field>
        <b-field label="Product Manager Email" class="column">
          <b-input
            placeholder="Enter Product Manager Email"
            type="text"
            required
            v-model="prodMngrEmail"
          >
          </b-input>
        </b-field>
        <b-field label="Product Specialist Name" class="column">
          <b-input
            placeholder="Enter Product Specialist Name"
            type="text"
            required
            v-model="prodSpclstName"
          >
          </b-input>
        </b-field>
        <b-field label="Product Specialist Email" class="column">
          <b-input
            placeholder="Enter Product Specialist Email"
            type="text"
            required
            v-model="prodSpclstEmail"
          >
          </b-input>
        </b-field>
        <span>
          <b-button
            type="is-info"
            class="column ni-update-mcs-button"
            @click="
              mcsCode &&
              prodMngrName &&
              prodMngrEmail &&
              prodSpclstName &&
              prodSpclstEmail
                ? updateMcsDetails()
                : ''
            "
          >
            Add/Update
          </b-button>
        </span>
      </div>
      <div>
        <div class="pagination-wrapper">
          <div class="pagination-header">
            <b-button
              v-show="showMCSPreviousButton"
              @click="
                mcsPageIndex = mcsPageIndex - 1;
                getMcsDetails();
              "
              >Previous</b-button
            >
            <b-button
              class="apply-filter"
              v-show="showMCSFirstButton"
              @click="
                mcsPageIndex = 1;
                getMcsDetails();
              "
              >First</b-button
            >
            <span class="page-index"
              >{{ minMCSPageIndex }} to {{ maxMCSPageIndex }} of
              {{ mcsTotalResults }}</span
            >
            <b-button
              v-show="showMCSLastButton"
              @click="
                mcsPageIndex = mcsTotalPages;
                getMcsDetails();
              "
              >Last</b-button
            >
            <b-button
              class="apply-filter"
              v-show="showMCSNextButton"
              @click="
                mcsPageIndex = mcsPageIndex + 1;
                getMcsDetails();
              "
              >Next</b-button
            >
            <span class="page-navigator" v-show="mcsTotalResults > 10"
              ><span class="show-text">Show</span
              ><b-select
                class="page-display-number"
                v-model="numberOfMCSItemsPerPage"
                @input="
                  mcsPageIndex =
                    Math.floor(minMCSPageIndex / numberOfMCSItemsPerPage) + 1;
                  getMcsDetails();
                "
                ><option value="10">10</option>
                <option value="20">20</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </b-select></span
            >
          </div>
        </div>
      </div>
      <div class="new-item-mcs-table-wrapper">
        <b-table :data="mcsData" :columns="mcsColumns"> </b-table>
      </div>
    </b-tab-item>
    <b-tab-item label="Leaf Node Data">
      <div class="columns leaf-node-input-wrapper">
        <b-field label="Leaf Node Key" class="column">
          <b-input
            placeholder="Enter Leaf Node Key"
            type="text"
            required
            v-model="leafNodeKey"
          >
          </b-input>
        </b-field>
        <b-field label="Leaf Node Description" class="column">
          <b-input
            placeholder="Enter Leaf Node Description"
            type="text"
            required
            v-model="leafNodeDesc"
          >
          </b-input>
        </b-field>
        <span>
          <b-button
            type="is-info"
            class="column ni-update-leaf-node-button"
            @click="leafNodeKey && leafNodeDesc ? updateLeafNodeDetails() : ''"
          >
            Add/Update
          </b-button>
        </span>
      </div>
      <div>
        <div class="pagination-wrapper">
          <div class="pagination-header">
            <b-button
              v-show="showLeafNodePreviousButton"
              @click="
                leafNodePageIndex = leafNodePageIndex - 1;
                getLeafNodeDetails();
              "
              >Previous</b-button
            >
            <b-button
              class="apply-filter"
              v-show="showLeafNodeFirstButton"
              @click="
                leafNodePageIndex = 1;
                getLeafNodeDetails();
              "
              >First</b-button
            >
            <span class="page-index"
              >{{ minLeafNodePageIndex }} to {{ maxLeafNodePageIndex }} of
              {{ leafNodeTotalResults }}</span
            >
            <b-button
              v-show="showLeafNodeLastButton"
              @click="
                leafNodePageIndex = leafNodeTotalPages;
                getLeafNodeDetails();
              "
              >Last</b-button
            >
            <b-button
              class="apply-filter"
              v-show="showLeafNodeNextButton"
              @click="
                leafNodePageIndex = leafNodePageIndex + 1;
                getLeafNodeDetails();
              "
              >Next</b-button
            >
            <span class="page-navigator" v-show="leafNodeTotalResults > 10"
              ><span class="show-text">Show</span
              ><b-select
                class="page-display-number"
                v-model="numberOfLeafNodeItemsPerPage"
                @input="
                  mcsPageIndex =
                    Math.floor(
                      minLeafNodePageIndex / numberOfLeafNodeItemsPerPage
                    ) + 1;
                  getLeafNodeDetails();
                "
                ><option value="10">10</option>
                <option value="20">20</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </b-select></span
            >
          </div>
        </div>
      </div>
      <div class="new-item-mcs-table-wrapper">
        <b-table :data="leafNodeData" :columns="leafNodeColumns"> </b-table>
      </div>
    </b-tab-item>
    <b-tab-item label="Mainframe Jobs">
      <b-table
        :data="mainframeJobsData"
        :columns="mainframeJobsColumns"
      ></b-table>
    </b-tab-item>
  </b-tabs>
</template>

<script>
import BTabItem from "buefy/src/components/tabs/TabItem";
export default {
  name: "SuperUserFunctionsComponent",
  components: { BTabItem },
  data() {
    return {
      activeTab: 0,
      data: [],
      searchVN: "",
      vendorNumber: "",
      vendorName: "",
      vnCategory: "",
      vnMCSCode: "",
      vendorColumns: [
        { field: "vendorNumber", label: "Vendor Number" },
        { field: "vendorName", label: "Vendor Name" },
        { field: "mcsCode", label: "MCS Code" },
        { field: "vnCategory", label: "Vendor Category" }
      ],
      mcsData: [],
      mcsCode: "",
      prodMngrName: "",
      prodMngrEmail: "",
      prodSpclstName: "",
      prodSpclstEmail: "",
      mcsColumns: [
        { field: "mcsCode", label: "MCS Code" },
        { field: "prodMngrName", label: "Product Manager Name" },
        { field: "prodMngrEmail", label: "Product Manager Email" },
        { field: "prodSpclstName", label: "Product Specialist Name" },
        { field: "prodSpclstEmail", label: "Product Specialist Email" }
      ],
      leafNodeData: [],
      leafNodeKey: "",
      leafNodeDesc: "",
      leafNodeColumns: [
        { field: "taxoCodeKey", label: "Leaf Node Key" },
        { field: "taxoCodeDesc", label: "Leaf Node Description" },
        { field: "createdBy", label: "Created By" },
        { field: "updatedBy", label: "Updated By" }
      ],
      mainframeJobsData: [],
      mainframeJobsColumns: [
        { field: "jobDesc", label: "Mainframe Job Description" },
        { field: "lastExecutionTime", label: "Last Execution time" },
        { field: "nextExecutionTime", label: "Next Execution time" },
        { field: "comments", label: "Comments" }
      ],
      vnPageIndex: 1,
      minVNPageIndex: "",
      maxVNPageIndex: "",
      vnTotalResults: "",
      vnTotalPages: "",
      showVNPreviousButton: true,
      showNextButton: true,
      showVNFirstButton: true,
      showVNLastButton: true,
      numberOfVNItemsPerPage: 10,
      mcsPageIndex: 1,
      minMCSPageIndex: "",
      maxMCSPageIndex: "",
      mcsTotalResults: "",
      mcsTotalPages: "",
      showMcsInputWrapper: false,
      showMCSPreviousButton: true,
      showMCSNextButton: true,
      showMCSFirstButton: true,
      showMCSLastButton: true,
      numberOfMCSItemsPerPage: 10,
      leafNodePageIndex: 1,
      minLeafNodePageIndex: "",
      maxLeafNodePageIndex: "",
      leafNodeTotalResults: "",
      leafNodeTotalPages: "",
      showLeafNodePreviousButton: true,
      showLeafNodeNextButton: true,
      showLeafNodeFirstButton: true,
      showLeafNodeLastButton: true,
      numberOfLeafNodeItemsPerPage: 10
    };
  },
  watch: {
    activeTab(value) {
      switch (value) {
        case 0:
          this.getAllVendorDetails();
          break;
        case 1:
          this.getMcsDetails();
          break;
        case 2:
          this.getLeafNodeDetails();
          break;
        case 3:
          this.getMFLoadJobs();
          break;
        default:
          this.getAllVendorDetails();
          break;
      }
    }
  },
  mounted() {
    this.getAllVendorDetails();
  },
  methods: {
    addVendorDetails() {
      var superUserFunctionsComponentScope = this;
      superUserFunctionsComponentScope.isLoading = true;
      var args = {};
      args.headers = {
        "content-type": "application/json"
      };
      superUserFunctionsComponentScope.$http
        .post(
          `${process.env.VUE_APP_API_BASE_DOMAIN}updateVendordetails?vendorNumber=${this.vendorNumber}&vendorName=${this.vendorName}&vnCategory=${this.vnCategory}&mcsCode=${this.vnMCSCode}`,
          args
        )
        .then(function(response) {
          superUserFunctionsComponentScope.isLoading = false;
          superUserFunctionsComponentScope.$buefy.dialog.alert({
            message: `Vendor Details  added/updated Successfully.`,
            confirmText: "OK",
            type: "is-success",
            onConfirm: () => (
              superUserFunctionsComponentScope.resetVendorValues(),
              superUserFunctionsComponentScope.getAllVendorDetails()
            )
          });
        })
        // eslint-disable-next-line no-unused-vars
        .catch(function(error) {
          superUserFunctionsComponentScope.resetVendorValues();
          superUserFunctionsComponentScope.isLoading = false;
          superUserFunctionsComponentScope.$buefy.dialog.alert({
            message: `Failed to add Vendor. Please check for invalid data and/or clear the cache and try again. If the problem persists, please contact the IT Support at NewItem.IT.Support@thermofisher.com`,
            confirmText: "OK",
            type: "is-danger"
          });
        });
    },
    resetVendorValues() {
      (this.vendorNumber = ""),
        (this.vendorName = ""),
        (this.vnMCSCode = ""),
        (this.vnCategory = "");
    },
    getAllVendorDetails() {
      var superUserFunctionsComponentScope = this;

      superUserFunctionsComponentScope.isLoading = true;
      superUserFunctionsComponentScope.$http
        .get(
          `${process.env.VUE_APP_API_BASE_DOMAIN}loadVendorDetails?pageNbr=${this.vnPageIndex}&pageSize=${this.numberOfVNItemsPerPage}`
        )
        .then(function(response) {
          response.data.startIndex
            ? (superUserFunctionsComponentScope.minVNPageIndex =
                response.data.startIndex)
            : (superUserFunctionsComponentScope.minVNPageIndex = 0);
          response.data.endIndex
            ? (superUserFunctionsComponentScope.maxVNPageIndex =
                response.data.endIndex)
            : (superUserFunctionsComponentScope.maxVNPageIndex = 0);
          response.data.totalCount
            ? (superUserFunctionsComponentScope.vnTotalResults =
                response.data.totalCount)
            : (superUserFunctionsComponentScope.vnTotalResults = 0);
          response.data.totalPages !== undefined
            ? (superUserFunctionsComponentScope.vnTotalPages =
                response.data.totalPages)
            : (superUserFunctionsComponentScope.vnTotalPages = 0);
          if (response.data.startIndex <= 1) {
            superUserFunctionsComponentScope.showVNPreviousButton = false;
            superUserFunctionsComponentScope.showVNFirstButton = false;
          } else {
            superUserFunctionsComponentScope.showVNPreviousButton = true;
            superUserFunctionsComponentScope.showVNFirstButton = true;
          }
          if (
            superUserFunctionsComponentScope.vnPageIndex >=
            superUserFunctionsComponentScope.vnTotalPages
          ) {
            superUserFunctionsComponentScope.showVNNextButton = false;
            superUserFunctionsComponentScope.showVNLastButton = false;
          } else {
            superUserFunctionsComponentScope.showNextButton = true;
            superUserFunctionsComponentScope.showVNLastButton = true;
          }
          superUserFunctionsComponentScope.isLoading = false;
          superUserFunctionsComponentScope.showSubmissionsViewError = false;
          superUserFunctionsComponentScope.data =
            response.data.psfsNewItemVendorTb;
        })
        // eslint-disable-next-line no-unused-vars
        .catch(function(error) {
          superUserFunctionsComponentScope.isLoading = false;
          superUserFunctionsComponentScope.showSubmissionsViewError = true;
          superUserFunctionsComponentScope.submissionsErrorText =
            "Please clear the cache and try again. If the problem persists, please contact the IT Support at NewItem.IT.Support@thermofisher.com";
        });
    },
    getAllVendorDetailsBySearch() {
      var superUserFunctionsComponentScope = this;
      var requestPayload = {};
      superUserFunctionsComponentScope.isLoading = true;
      superUserFunctionsComponentScope.$http
        .get(
          `${process.env.VUE_APP_API_BASE_DOMAIN}loadVendorDetails?vendorNumber=${this.searchVN}&pageNbr=${this.vnPageIndex}&pageSize=${this.numberOfVNItemsPerPage}`,
          requestPayload
        )
        // eslint-disable-next-line no-unused-vars
        .then(function(response) {
          response.data.startIndex
            ? (superUserFunctionsComponentScope.minVNPageIndex =
                response.data.startIndex)
            : (superUserFunctionsComponentScope.minVNPageIndex = 0);
          response.data.endIndex
            ? (superUserFunctionsComponentScope.maxVNPageIndex =
                response.data.endIndex)
            : (superUserFunctionsComponentScope.maxVNPageIndex = 0);
          response.data.totalCount
            ? (superUserFunctionsComponentScope.vnTotalResults =
                response.data.totalCount)
            : (superUserFunctionsComponentScope.vnTotalResults = 0);
          response.data.totalPages !== undefined
            ? (superUserFunctionsComponentScope.vnTotalPages =
                response.data.totalPages)
            : (superUserFunctionsComponentScope.vnTotalPages = 0);
          superUserFunctionsComponentScope.vnPageIndex =
            Math.floor(
              superUserFunctionsComponentScope.minVNPageIndex /
                response.data.pageSize
            ) + 1;
          if (response.data.startIndex <= 1) {
            superUserFunctionsComponentScope.showVNPreviousButton = false;
            superUserFunctionsComponentScope.showVNFirstButton = false;
          } else {
            superUserFunctionsComponentScope.showVNPreviousButton = true;
            superUserFunctionsComponentScope.showVNFirstButton = true;
          }
          if (
            superUserFunctionsComponentScope.vnPageIndex >=
            superUserFunctionsComponentScope.vnTotalPages
          ) {
            superUserFunctionsComponentScope.showVNNextButton = false;
            superUserFunctionsComponentScope.showVNLastButton = false;
          } else {
            superUserFunctionsComponentScope.showVNNextButton = true;
            superUserFunctionsComponentScope.showVNLastButton = true;
          }
          superUserFunctionsComponentScope.isLoading = false;
          superUserFunctionsComponentScope.showSubmissionsViewError = false;
          superUserFunctionsComponentScope.data =
            response.data.psfsNewItemVendorTb;
        })
        // eslint-disable-next-line no-unused-vars
        .catch(function(error) {
          superUserFunctionsComponentScope.isLoading = false;
          superUserFunctionsComponentScope.showSubmissionsViewError = true;
          superUserFunctionsComponentScope.submissionsErrorText =
            "Failed to load search result. Please check for invalid data and/or clear the cache and try again. If the problem persists, please contact the IT Support at NewItem.IT.Support@thermofisher.com";
        });
    },
    getMcsDetails() {
      var superUserFunctionsComponentScope = this;
      superUserFunctionsComponentScope.isLoading = true;

      superUserFunctionsComponentScope.$http
        .get(
          `${process.env.VUE_APP_API_BASE_DOMAIN}loadMCSDetails?pageNbr=${this.mcsPageIndex}&pageSize=${this.numberOfMCSItemsPerPage}`
        )
        .then(function(response) {
          response.data.startIndex
            ? (superUserFunctionsComponentScope.minMCSPageIndex =
                response.data.startIndex)
            : (superUserFunctionsComponentScope.minMCSPageIndex = 0);
          response.data.endIndex
            ? (superUserFunctionsComponentScope.maxMCSPageIndex =
                response.data.endIndex)
            : (superUserFunctionsComponentScope.maxMCSPageIndex = 0);
          response.data.totalCount
            ? (superUserFunctionsComponentScope.mcsTotalResults =
                response.data.totalCount)
            : (superUserFunctionsComponentScope.mcsTotalResults = 0);
          response.data.totalPages !== undefined
            ? (superUserFunctionsComponentScope.mcsTotalPages =
                response.data.totalPages)
            : (superUserFunctionsComponentScope.mcsTotalPages = 0);
          if (response.data.startIndex <= 1) {
            superUserFunctionsComponentScope.showMCSPreviousButton = false;
            superUserFunctionsComponentScope.showMCSFirstButton = false;
          } else {
            superUserFunctionsComponentScope.showMCSPreviousButton = true;
            superUserFunctionsComponentScope.showMCSFirstButton = true;
          }
          if (
            superUserFunctionsComponentScope.mcsPageIndex >=
            superUserFunctionsComponentScope.mcsTotalPages
          ) {
            superUserFunctionsComponentScope.showMCSNextButton = false;
            superUserFunctionsComponentScope.showMCSLastButton = false;
          } else {
            superUserFunctionsComponentScope.showMCSNextButton = true;
            superUserFunctionsComponentScope.showMCSLastButton = true;
          }
          superUserFunctionsComponentScope.isLoading = false;
          superUserFunctionsComponentScope.showSubmissionsViewError = false;
          superUserFunctionsComponentScope.mcsData =
            response.data.psfsNewItemVendorMCSTb;
        })
        // eslint-disable-next-line no-unused-vars
        .catch(function(error) {
          superUserFunctionsComponentScope.isLoading = false;
          superUserFunctionsComponentScope.showSubmissionsViewError = true;
          superUserFunctionsComponentScope.submissionsErrorText =
            "Failed to load MCS data. Please clear the cache and try again. If the problem persists, please contact the IT Support at NewItem.IT.Support@thermofisher.com";
        });
    },
    updateMcsDetails() {
      var superUserFunctionsComponentScope = this;
      var requestPayload = {};
      requestPayload.mcsCode = superUserFunctionsComponentScope.mcsCode;
      requestPayload.prodMngrName =
        superUserFunctionsComponentScope.prodMngrName;
      requestPayload.prodMngrEmail =
        superUserFunctionsComponentScope.prodMngrEmail;
      requestPayload.prodSpclstName =
        superUserFunctionsComponentScope.prodSpclstName;
      requestPayload.prodSpclstEmail =
        superUserFunctionsComponentScope.prodSpclstEmail;

      superUserFunctionsComponentScope.isLoading = true;
      superUserFunctionsComponentScope.$http
        .post(
          `${process.env.VUE_APP_API_BASE_DOMAIN}updateMCSDetails`,
          requestPayload
        )
        .then(function(response) {
          superUserFunctionsComponentScope.isLoading = false;
          superUserFunctionsComponentScope.$buefy.dialog.alert({
            message: `MCS Details updated Successfully.`,
            confirmText: "OK",
            type: "is-success",
            onConfirm: () => (
              superUserFunctionsComponentScope.resetMCSValues(),
              superUserFunctionsComponentScope.getMcsDetails()
            )
          });
        })
        // eslint-disable-next-line no-unused-vars
        .catch(function(error) {
          superUserFunctionsComponentScope.resetMCSValues();
          superUserFunctionsComponentScope.isLoading = false;
          superUserFunctionsComponentScope.$buefy.dialog.alert({
            message: `Failed to add/update MCS detail. Please check for invalid data and/or clear the cache and try again. If the problem persists, please contact the IT Support at NewItem.IT.Support@thermofisher.com`,
            confirmText: "OK",
            type: "is-danger"
          });
        });
    },
    resetMCSValues() {
      (this.mcsCode = ""),
        (this.prodMngrName = ""),
        (this.prodMngrEmail = ""),
        (this.prodSpclstName = ""),
        (this.prodSpclstEmail = "");
    },
    getLeafNodeDetails() {
      var superUserFunctionsComponentScope = this;
      superUserFunctionsComponentScope.isLoading = true;

      superUserFunctionsComponentScope.$http
        .get(
          `${process.env.VUE_APP_API_BASE_DOMAIN}loadLeafNodeDetails?pageNbr=${this.leafNodePageIndex}&pageSize=${this.numberOfLeafNodeItemsPerPage}`
        )
        .then(function(response) {
          response.data.startIndex
            ? (superUserFunctionsComponentScope.minLeafNodePageIndex =
                response.data.startIndex)
            : (superUserFunctionsComponentScope.minLeafNodePageIndex = 0);
          response.data.endIndex
            ? (superUserFunctionsComponentScope.maxLeafNodePageIndex =
                response.data.endIndex)
            : (superUserFunctionsComponentScope.maxLeafNodePageIndex = 0);
          response.data.totalCount
            ? (superUserFunctionsComponentScope.leafNodeTotalResults =
                response.data.totalCount)
            : (superUserFunctionsComponentScope.leafNodeTotalResults = 0);
          response.data.totalPages !== undefined
            ? (superUserFunctionsComponentScope.leafNodeTotalPages =
                response.data.totalPages)
            : (superUserFunctionsComponentScope.leafNodeTotalPages = 0);
          if (response.data.startIndex <= 1) {
            superUserFunctionsComponentScope.showLeafNodePreviousButton = false;
            superUserFunctionsComponentScope.showLeafNodeFirstButton = false;
          } else {
            superUserFunctionsComponentScope.showLeafNodePreviousButton = true;
            superUserFunctionsComponentScope.showLeafNodeFirstButton = true;
          }
          if (
            superUserFunctionsComponentScope.leafNodePageIndex >=
            superUserFunctionsComponentScope.leafNodeTotalPages
          ) {
            superUserFunctionsComponentScope.showLeafNodeNextButton = false;
            superUserFunctionsComponentScope.showLeafNodeLastButton = false;
          } else {
            superUserFunctionsComponentScope.showLeafNodeNextButton = true;
            superUserFunctionsComponentScope.showLeafNodeLastButton = true;
          }
          superUserFunctionsComponentScope.isLoading = false;
          superUserFunctionsComponentScope.showSubmissionsViewError = false;
          superUserFunctionsComponentScope.leafNodeData =
            response.data.psfsNewItemTaxoCodesTb;
        })
        // eslint-disable-next-line no-unused-vars
        .catch(function(error) {
          superUserFunctionsComponentScope.isLoading = false;
          superUserFunctionsComponentScope.showSubmissionsViewError = true;
          superUserFunctionsComponentScope.submissionsErrorText =
            "Failed to load Leaf Node data. Please clear the cache and try again. If the problem persists, please contact the IT Support at NewItem.IT.Support@thermofisher.com";
        });
    },
    updateLeafNodeDetails() {
      var superUserFunctionsComponentScope = this;
      var requestPayload = {};
      requestPayload.taxoCodeKey = superUserFunctionsComponentScope.leafNodeKey;
      requestPayload.taxoCodeDesc =
        superUserFunctionsComponentScope.leafNodeDesc;
      requestPayload.createdBy = window.$cookies.get("ni_key").networkId;

      superUserFunctionsComponentScope.isLoading = true;
      superUserFunctionsComponentScope.$http
        .post(
          `${process.env.VUE_APP_API_BASE_DOMAIN}updateLeafNodesDetails`,
          requestPayload
        )
        .then(function(response) {
          superUserFunctionsComponentScope.isLoading = false;
          superUserFunctionsComponentScope.$buefy.dialog.alert({
            message: `Leaf Node Details updated Successfully.`,
            confirmText: "OK",
            type: "is-success",
            onConfirm: () => (
              superUserFunctionsComponentScope.resetLeafNodeValues(),
              superUserFunctionsComponentScope.getLeafNodeDetails()
            )
          });
        })
        // eslint-disable-next-line no-unused-vars
        .catch(function(error) {
          superUserFunctionsComponentScope.resetLeafNodeValues();
          superUserFunctionsComponentScope.isLoading = false;
          superUserFunctionsComponentScope.$buefy.dialog.alert({
            message: `Failed to add/update MCS detail. Please check for invalid data and/or clear the cache and try again. If the problem persists, please contact the IT Support at NewItem.IT.Support@thermofisher.com`,
            confirmText: "OK",
            type: "is-danger"
          });
        });
    },
    resetLeafNodeValues() {
      (this.leafNodeKey = ""), (this.leafNodeDesc = "");
    },
    getMFLoadJobs() {
      var superUserFunctionsComponentScope = this;
      superUserFunctionsComponentScope.isLoading = true;

      superUserFunctionsComponentScope.$http
        .get(`${process.env.VUE_APP_API_BASE_DOMAIN}getMFJobsStatus`)
        .then(function(response) {
          superUserFunctionsComponentScope.isLoading = false;
          console.log(response.data);
          superUserFunctionsComponentScope.showSubmissionsViewError = false;
          superUserFunctionsComponentScope.mainframeJobsData = [
            {
              jobDesc: "Mainframe Load Job",
              lastExecutionTime: response.data.mfLoadLastJob
                ? response.data.mfLoadLastJob.split("T")[0] +
                  " " +
                  response.data.mfLoadLastJob.split("T")[1].split(".")[0]
                : "",
              nextExecutionTime: superUserFunctionsComponentScope.mainFrameLoadJobNextExecTime(),
              comments: response.data.mfJobComments
                ? response.data.mfJobComments
                : ""
            },
            {
              jobDesc: "Load Recycled Items into New Item",
              lastExecutionTime: response.data.recyclLastJob
                ? response.data.recyclLastJob.split("T")[0] +
                  " " +
                  response.data.recyclLastJob.split("T")[1].split(".")[0]
                : "",
              nextExecutionTime: superUserFunctionsComponentScope.recycledItemsIntoNINextExecTime(),
              comments: response.data.recycljobComments
                ? response.data.recycljobComments
                : ""
            },
            {
              jobDesc: "CAS Upload Job",
              lastExecutionTime: response.data.casLastJob
                ? response.data.casLastJob.split("T")[0] +
                  " " +
                  response.data.casLastJob.split("T")[1].split(".")[0]
                : "",
              nextExecutionTime: superUserFunctionsComponentScope.casUploadJobNextExecTime(),
              comments: response.data.casJobcomments
                ? response.data.casJobcomments
                : ""
            }
          ];
        })
        // eslint-disable-next-line no-unused-vars
        .catch(function(error) {
          superUserFunctionsComponentScope.isLoading = false;
          superUserFunctionsComponentScope.showSubmissionsViewError = true;
          superUserFunctionsComponentScope.submissionsErrorText =
            "Failed to load Mainframe Jobs data. Please clear the cache and try again. If the problem persists, please contact the IT Support at NewItem.IT.Support@thermofisher.com";
        });
    },
    mainFrameLoadJobNextExecTime() {
      var currentDtWithTime = new Date();
      if (
        Date.parse(currentDtWithTime) >
        Date.parse(
          new Date(
            currentDtWithTime.getFullYear(),
            currentDtWithTime.getMonth(),
            currentDtWithTime.getDate(),
            16
          )
        )
      ) {
        var displayNextDay = new Date(
          new Date().setDate(currentDtWithTime.getDate() + 1)
        );
        return `${displayNextDay.getFullYear() +
          "-" +
          ("0" + (displayNextDay.getMonth() + 1)).slice(-2) +
          "-" +
          ("0" + displayNextDay.getDate()).slice(-2) +
          " " +
          "16:00:00"}`;
      } else {
        return `${currentDtWithTime.getFullYear() +
          "-" +
          ("0" + (currentDtWithTime.getMonth() + 1)).slice(-2) +
          "-" +
          ("0" + currentDtWithTime.getDate()).slice(-2) +
          " " +
          "16:00:00"}`;
      }
    },
    recycledItemsIntoNINextExecTime() {
      var currentDtWithTime = new Date();
      if (
        Date.parse(currentDtWithTime) >
        Date.parse(
          new Date(
            currentDtWithTime.getFullYear(),
            currentDtWithTime.getMonth(),
            currentDtWithTime.getDate(),
            21
          )
        )
      ) {
        var displayNextDay = new Date(
          new Date().setDate(currentDtWithTime.getDate() + 1)
        );
        return `${displayNextDay.getFullYear() +
          "-" +
          ("0" + (displayNextDay.getMonth() + 1)).slice(-2) +
          "-" +
          ("0" + displayNextDay.getDate()).slice(-2) +
          " " +
          "21:00:00"}`;
      } else {
        return `${currentDtWithTime.getFullYear() +
          "-" +
          ("0" + (currentDtWithTime.getMonth() + 1)).slice(-2) +
          "-" +
          ("0" + currentDtWithTime.getDate()).slice(-2) +
          " " +
          "21:00:00"}`;
      }
    },
    casUploadJobNextExecTime() {
      var currentDtWithTime = new Date();
      if (
        Date.parse(currentDtWithTime) >
        Date.parse(
          new Date(
            currentDtWithTime.getFullYear(),
            currentDtWithTime.getMonth(),
            currentDtWithTime.getDate(),
            17,
            30
          )
        )
      ) {
        var displayNextDay = new Date(
          new Date().setDate(currentDtWithTime.getDate() + 1)
        );
        return `${displayNextDay.getFullYear() +
          "-" +
          ("0" + (displayNextDay.getMonth() + 1)).slice(-2) +
          "-" +
          ("0" + displayNextDay.getDate()).slice(-2) +
          " " +
          "17:30:00"}`;
      } else {
        return `${currentDtWithTime.getFullYear() +
          "-" +
          ("0" + (currentDtWithTime.getMonth() + 1)).slice(-2) +
          "-" +
          ("0" + currentDtWithTime.getDate()).slice(-2) +
          " " +
          "17:30:00"}`;
      }
    }
  }
};
</script>

<style scoped></style>
